/* eslint-disable no-param-reassign */
import { sity, engines, gearboxes, crutch } from 'shared/modules/subjectiveText/allText';
import { buildInGenitiveCityHeader } from 'shared/modules';

const avaliableKeyFields = [
  'make',
  'model',
  'city',
  'generation',
  'gearbox',
  'engine',
  'body',
  'drive',
  // 'driveSelected',
  'isNew',
  'year',
  // 'makeTranslate',
  'country',
  // 'location'
  'transport',
  'transportType',
  'transporttype',
];

/**
 * Make pathes to compare and find needed function.
 * Like: body_engine_isnew
 * @param {object} inputParams 
 * @param {object} seoData 
 * @returns {object}
 */
function findSeoPath(inputParams, seoData) {
  const inputKeys = avaliableKeyFields.filter(
    k => inputParams[k] !== null && inputParams[k] !== undefined && inputParams[k] !== '',
  );

  const pathInput = inputKeys.sort().join('_').toLowerCase();

  const seoDataKeys = Object.keys(seoData || {});

  for (let i = 0, l = seoDataKeys.length; i < l; i += 1) {
    const path = seoDataKeys[i].split('_').sort().join('_');
    const pathLc = path.toLowerCase();
    const func = seoData[pathLc] || seoData[path];
    if (path === pathInput && func) {
      return { path, func };
    }
  }
  return {};
}

export function getCustomParams(data, t) {
  const { city, country, engine, gearbox } = data;

  const locale = t('locale');
  const buy = t('Купить');
  const newTxt = t('Новый');

  const newTxtLCase = newTxt.toLowerCase();
  const buyLCase = buy.toLowerCase();

  const inCity = sity[city]
    ? ` ${buildInGenitiveCityHeader(sity[city][locale].genitive)}`
    : buildInGenitiveCityHeader(t(city) || city) || '';

  const fromCountry = country && country.is_country ? country.from[locale] : '';
  const countryTitle = country && country.is_country ? t(country.title) : '';

  let customEngineAlt = engine;
  let customEngine = engine;
  let customEngineShort = engine;
  let customGearbox = gearbox;
  let customGearboxLCase = gearbox && gearbox.toLowerCase();

  if (engine in engines && engines[engine][locale]) {
    customEngineAlt = engines[engine][locale].altTitle;
    customEngine = engines[engine][locale].title;
    customEngineShort = engines[engine][locale].short;
  }

  if (gearbox in gearboxes && gearboxes[gearbox][locale]) {
    customGearbox = gearboxes[gearbox][locale].title;
    customGearboxLCase = customGearbox.toLowerCase();
  }
  const makeLocale = 'test'; // make[`${t('locale')}_title`] ? make[`${t('locale')}_title`] : make.title;

  return {
    buy,
    newTxt,
    newTxtLCase,
    buyLCase,

    customEngineShort,
    customEngineAlt,
    customEngine,

    customGearbox,
    customGearboxLCase,

    inCity: (inCity || '').trim(),
    fromCountry: (fromCountry || '').trim(),
    country: countryTitle,
    locale,
    t,
    makeLocale,
  };
}

/**
 * Parse input params and retrurn Object with 
 * @param {object} data 
 * @param {object} pathes 
 * @param {funciton} t 
 * @returns {object} { head: 'text for H1', title: 'text for eta Title', ... }
 */
export function paramsToSeoData(data, pathes, t) {
  try {
    const locale = t('locale');
    const isNew = !!data.isNew;
    if (data.transportCategoryTitleOrigin) {
      const subCategory = data.transportCategoryTitleOrigin;
      const subCategoryObject = crutch(isNew)[subCategory] || {};

      if (subCategoryObject[locale]) {
        const obj = subCategoryObject[locale];
        data.subCategory = subCategory || '';
        data.subCategoryHeader = obj.transportHeader || '';
        data.subCategoryPluralGenitive = obj.pluralGenitiveTransport || '';
        data.subCategoryPlural = obj.pluralTransport || '';
      }
    }

    if (data.transportTitleOrigin) {
      const transport = crutch(isNew)[data.transportTitleOrigin] || {};

      if (transport[locale]) {
        const obj = transport[locale];
        data.category = data.transportTitleOrigin || '';
        data.categoryPluralGenitive = obj.pluralGenitive || '';
        data.categoryPlural = obj.plural || '';
      }
    }

    data.transportType = data.subCategoryHeader || data.category;
    data.transportTypePlural = data.subCategoryPlural || data.categoryPlural;
    data.transportTypePluralGenitive =
      data.subCategoryPluralGenitive || data.categoryPluralGenitive;

    const { path, func } = findSeoPath(data, pathes);

    // ...
    // Here can be added some additional SEO searching by API or something else.
    // We have `path` (brand_model_...) and can use it.
    // ...
    if (path) {
      const customParams = getCustomParams(data, t);
      const res = func(data, customParams);
      const lc = customParams.locale;

      return {
        title: res[`title_${lc}`] || res.title,
        description: res[`description_${lc}`] || res.description,
        header: res[`header_${lc}`] || res.header,
      };
    }
    return {};
  } catch (err) {
    console.log('ERRPR: ', err);
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoDataFinder.js